/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var modelGet = require('common/util/modelGet');
var cleanUpResponse = require('../util/cleanUpResponse');

module.exports = function(payeezyView) {
  var deferred = $.Deferred();
  var taskId = modelGet(payeezyView.model, 'merchant_cookie_7');
  var transactionId = modelGet(payeezyView.model, 'merchant_cookie_8');
  $.soap({
    body: {
      UpdateEPPSessionInformation: {
        $xmlns: 'http://dobs.pa.gov/cm/epp/bpm/1.0',
        SamlArtifactCookieName: modelGet(payeezyView.model, 'merchant_cookie_1'),
        SamlArtifactCookieValue: modelGet(payeezyView.model, 'merchant_cookie_2'),
        PreloginCookieName: modelGet(payeezyView.model, 'merchant_cookie_3'),
        PreloginCookieValue: modelGet(payeezyView.model, 'merchant_cookie_4'),
        SessionTokenName: modelGet(payeezyView.model, 'merchant_cookie_5'),
        SessionTokenValue: modelGet(payeezyView.model, 'merchant_cookie_6'),
        TaskId: taskId != null ? taskId.replaceAll(',', '') : taskId,
        TransactionId: transactionId != null ? transactionId.replaceAll(',', '') : transactionId
      }
    },
    blueprintArrays: ['UpdateEPPSessionInformationResponse'],
    blueprint: {
      sessionInformationId: '$..SessionInformationId'
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      deferred.resolve(response.sessionInformationId);
    })
    .fail(function(err) {
      deferred.reject(err);
    });

  return deferred.promise();
};
